var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSidebarQuoteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16480_7707)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.1547 3H4.3732C3.62033 3 3.00781 3.6232 3.00781 4.38924C3.00781 14.525 2.94966 13.9011 3.14955 14.1045C6.05974 17.0656 5.87522 16.8936 5.977 16.9449C6.12255 17.0192 4.73275 16.9969 11.1547 16.9969C11.9075 16.9969 12.5201 16.3737 12.5201 15.6076V4.38924C12.5201 3.6232 11.9076 3 11.1547 3ZM5.70907 15.3178L4.65807 14.2484H5.70907V15.3178ZM11.5534 15.6076C11.5534 15.8313 11.3746 16.0133 11.1547 16.0133H6.67577V13.7566C6.67577 13.4849 6.45935 13.2648 6.19242 13.2648H3.9745V4.38924C3.9745 4.16556 4.15334 3.9836 4.3732 3.9836H11.1547C11.3745 3.9836 11.5534 4.16556 11.5534 4.38924V15.6076ZM14.7601 4.38924V15.6076C14.7601 16.3737 14.1475 16.9969 13.3947 16.9969C13.1277 16.9969 12.9113 16.7767 12.9113 16.5051C12.9113 16.2335 13.1277 16.0133 13.3947 16.0133C13.6145 16.0133 13.7934 15.8313 13.7934 15.6076V4.38924C13.7934 4.16556 13.6145 3.9836 13.3947 3.9836C13.1277 3.9836 12.9113 3.76343 12.9113 3.4918C12.9113 3.22017 13.1277 3 13.3947 3C14.1475 3 14.7601 3.6232 14.7601 4.38924ZM17 4.38924V15.6076C17 16.3737 16.3875 16.9969 15.6346 16.9969C15.3677 16.9969 15.1513 16.7767 15.1513 16.5051C15.1513 16.2335 15.3677 16.0133 15.6346 16.0133C15.8544 16.0133 16.0333 15.8313 16.0333 15.6076V4.38924C16.0333 4.16556 15.8545 3.9836 15.6346 3.9836C15.3677 3.9836 15.1513 3.76343 15.1513 3.4918C15.1513 3.22017 15.3677 3 15.6346 3C16.3875 3 17 3.6232 17 4.38924Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16480_7707"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarQuoteIcon);
export default __webpack_public_path__ + "static/media/sidebar-quote-icon.816f2a18f405acb47358c9ac545ac138.svg";
export { ForwardRef as ReactComponent };